<template>
  <div class="detail-form"
    v-loading="loading">
    <el-tabs v-model="activeTab"
      class="el-tabs-attr"
      tab-position="left">
      <el-tab-pane label="商品"
        name="product">
        <el-alert type="success"
          :closable="false">
          <span style="font-size:16px">{{current.parentLabel}}-{{current.className}}</span>
          <el-button type="primary" size="mini" style="margin-left: 10px" @click="updateProp(1)">更新商品模板属性</el-button>
        </el-alert>
        <category-props ref="product"
          type="product"
          name="商品"
          :classId='current.classId'
          :templateType="1"
          :base="list.productBaseTemplate || []"
          :extra="list.productExtraTemplate || []"></category-props>
      </el-tab-pane>
      <el-tab-pane label="批次"
        name="batch">
        <el-alert type="success"
          :closable="false">
          <span style="font-size:16px">{{current.parentLabel}}-{{current.className}}</span>
          <el-button type="primary" size="mini" style="margin-left: 10px" @click="updateProp(2)">更新批次模板属性</el-button>
        </el-alert>
        <category-props ref="batch"
          type="batch"
          name="批次"
          :classId='current.classId'
          :templateType="2"
          :base="list.batchBaseTemplate || []"
          :extra="list.batchExtraTemplate || []"></category-props>
      </el-tab-pane>
    </el-tabs>
    <div style="text-align: center;">
      <el-button type="primary"
        @click="saveProps">保存</el-button>
    </div>
  </div>
</template>

<script>
import CategoryProps from '@/components/business/industry/category-props.vue'
export default {
  name: 'industry-category-detail',
  components: { CategoryProps },
  props: {},
  data () {
    return {
      loading: false,
      activeTab: 'product',
      current: {},
      list: { productBaseTemplate: [], productExtraTemplate: [], batchBaseTemplate: [], batchExtraTemplate: [] }
    }
  },
  methods: {
    updateProp (templateType) {
      this.$confirm('此操作会把【属性模板】新增的字段添加到当前行业上，请确认已保存当前配置?', '提示', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('industry/restorecategorytemplate', {
          payload: { classId: this.current.classId, templateType },
          success: (res) => {
            this.loading = false
            this.getcategorytemplate(this.current)
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    getcategorytemplate (obj) {
      this.loading = true
      this.current = obj
      this.$store.dispatch('industry/getcategorytemplate', {
        payload: { classId: obj.classId },
        success: (res) => {
          this.loading = false
          this.list = res.data
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    saveProps () {
      let refs = this.$refs
      let primiseArray = ['product', 'batch'].map(item => {
        return refs[item].validate()
      })
      Promise.all(primiseArray)
        .then(res => {
          let list = {}
          res.forEach(item => {
            list[item.type + 'BaseTemplate'] = item.baseTemplate
            list[item.type + 'ExtraTemplate'] = item.extraTemplate.map((item, index) => {
              item.sortNumber = index
              return item
            })
          })
          this.loading = true
          this.$store.dispatch('industry/updatecategorytemplate', {
            payload: { ...this.list, ...list },
            success: (res) => {
              this.loading = false
              this.getcategorytemplate(this.current)
            },
            fail: () => {
              this.loading = false
            }
          })
        })
        .catch(err => {
          this.$message.error(err.message)
          this.activeTab = err.type
        })
    }
  }
}
</script>
<style lang="stylus">
.el-tabs-attr {
  padding: 15px 10px 0 0;
}
</style>
